import { useMutation, useQuery } from '@apollo/client'
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import * as Yup from 'yup'
import {
  CREATE_RATING,
  GET_ALL_FEEDBACK_TYPE,
  GET_ALL_USER_TYPES_RATING,
  GET_CATEGORIES_OPTIONS_BY_GROUP,
  GET_GROUPS_OPTIONS_BY_AREA,
  GET_SUB_CATEGORIES_OPTIONS_BY_CATEGORY,
  GET_USER_RATING_BY_ID,
  UPDATE_RATING,
} from '../../../../../graphql/Catalog/UsersRating/usersRating'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import Box from '../../../../Global/Box'
import InputController from '../../../../Global/InputController'
import { GET_ALL_GROUPS } from '../../../../../graphql/Catalog/Groups/groups'
import { GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT } from '../../../../../graphql/Catalog/Groups/groupsCategories'
import { GET_USERS_BY_CATEGORY_GROUP_ID } from '../../../../../graphql/Catalog/Users/user'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import { useHistory } from 'react-router-dom'

const FormUsersRatings = ({
  backPage,
  ratingId,
  refetchMain,
  setCloseModal,
}) => {
  const history = useHistory()
  const { hideLoading, showLoading } = useLoading()
  const [options, setOptions] = useState({
    groups: [],
    categories: [],
    subCategories: [],
    usersToCategories: [],
    feedback_types: [],
    user_types: [],
  })
  const [selected, setSelected] = useState({
    group: false,
    category: false,
    subCategoryId: false,
    user: false,
    userType: false,
  })

  const validationSchema = Yup.object().shape({
    user_type: Yup.string().required('El campo es requerido'),
    group_id: Yup.string().when('user_type', (userType, schema) =>
      userType === 'attention_citizens'
        ? schema.notRequired().nullable()
        : schema.required('El campo es requerido')
    ),
    category_id: Yup.string().when('user_type', (userType, schema) =>
      userType === 'attention_citizens'
        ? schema.notRequired().nullable()
        : schema.required('El campo es requerido')
    ),
    user_id: Yup.string().required('El campo es requerido'),
    // rating: Yup.number()
    //   .oneOf([1, 2, 3, 4, 5], 'La calificación debe ser un número entre 1 y 5')
    //   .typeError('La calificación debe ser un número entre 1 y 5')
    //   .required('El campo es requerido'),
    comment: Yup.string().required('El campo es requerido'),
    feedback_type: Yup.string().required('El campo es requerido'),
    group_sub_category_id: Yup.string().when('user_type', (userType, schema) =>
      userType === 'process'
        ? schema.required('El campo es requerido')
        : schema.notRequired()
    ),
  })

  const {
    methods,
    handleSubmit,
    control,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const {
    loading: userRatingLoading,
    error: userRatingError,
    data: userRatingData,
  } = useQuery(GET_USER_RATING_BY_ID, {
    variables: {
      id: +ratingId,
    },
    fetchPolicy: 'no-cache',
    skip: !ratingId,
  })

  const {
    data: dataGroups,
    loading: loadingGroups,
    error: errorGroups,
  } = useQuery(GET_GROUPS_OPTIONS_BY_AREA, {
    variables: {
      userType: selected.userType ? selected.userType : null,
    },
    fetchPolicy: 'no-cache',
    skip: !selected.userType,
  })

  const {
    data: dataCategories,
    loading: loadingCategories,
    error: errorCategories,
  } = useQuery(GET_CATEGORIES_OPTIONS_BY_GROUP, {
    variables: {
      userType: selected.userType,
      parentId: selected.group ? selected.group : null,
    },
    fetchPolicy: 'no-cache',
    skip: !selected.group && !selected.userType,
  })

  const {
    loading: loadingSubCategories,
    error: errorSubCategories,
    data: dataSubCategories,
  } = useQuery(GET_SUB_CATEGORIES_OPTIONS_BY_CATEGORY, {
    variables: {
      userType: selected.userType,
      parentCategoryId: selected.category ? selected.category : null,
    },
    fetchPolicy: 'no-cache',
    skip: !selected.category && !selected.userType,
  })

  const {
    loading: feedbackTypesLoading,
    error: feedbackTypesError,
    data: feedbackTypesData,
  } = useQuery(GET_ALL_FEEDBACK_TYPE, {
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingUsersToCategories,
    error: errorUsersToCategories,
    data: dataUsersToCategories,
  } = useQuery(GET_USERS_BY_CATEGORY_GROUP_ID, {
    variables: {
      subCategoryId: selected.subCategoryId ? selected.subCategoryId : null,
      userType: selected.userType,
      parentCategoryId: selected.category ? selected.category : null,
    },
    fetchPolicy: 'no-cache',
    skip: !selected.category && !selected.userType,
  })

  const {
    loading: loadingUserTypes,
    error: errorUserTypes,
    data: dataUserTypes,
  } = useQuery(GET_ALL_USER_TYPES_RATING, {
    fetchPolicy: 'cache-and-network',
  })

  const [createRating] = useMutation(CREATE_RATING)
  const [updateRating] = useMutation(UPDATE_RATING)
  const [getCategoriesFetch] = useMutation(
    GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT
  )

  useEffect(() => {
    try {
      if (!ratingId) return
      if (userRatingLoading) return
      if (userRatingError) {
        return toastSweetAlert({
          mode: 'error',
          message: userRatingError.message,
        })
      }

      const resetValues = {
        group_id: userRatingData.getUserRatingById.group_id,
        category_id: userRatingData.getUserRatingById.group_category_id,
        user_id: userRatingData.getUserRatingById.user_id,
        // rating: userRatingData.getUserRatingById.rating,
        comment: userRatingData.getUserRatingById.comment,
        feedback_type: userRatingData.getUserRatingById.feedback_type,
        user_type: userRatingData.getUserRatingById.user_type,
        group_sub_category_id: userRatingData.getUserRatingById
          .group_sub_category_id
          ? userRatingData.getUserRatingById.group_sub_category_id
          : '',
      }

      setSelected({
        group: userRatingData.getUserRatingById.group_id,
        category: userRatingData.getUserRatingById.group_category_id,
        subCategoryId:
          userRatingData.getUserRatingById.user_type === 'process'
            ? userRatingData.getUserRatingById.group_sub_category_id
            : false,
        user: userRatingData.getUserRatingById.user_id,
        userType: userRatingData.getUserRatingById.user_type,
      })

      setValue('user_type', userRatingData.getUserRatingById.user_type)
      setValue('group_id', userRatingData.getUserRatingById.group_id)
      setValue(
        'category_id',
        userRatingData.getUserRatingById.group_category_id
      )
      setValue(
        'group_sub_category_id',
        userRatingData.getUserRatingById.group_sub_category_id
      )
      setValue('user_id', userRatingData.getUserRatingById.user_id)
      // setValue('rating', userRatingData.getUserRatingById.rating)

      reset(resetValues)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [userRatingData, userRatingError, userRatingLoading])
  useEffect(() => {
    if (!selected.userType) return

    if (selected.userType === 'attention_citizens') {
      setSelected((prev) => ({
        ...prev,
        group: 1,
        category: 1,
        subCategoryId: 1,
      }))
    }
  }, [selected.userType])

  useEffect(() => {
    try {
      if (feedbackTypesLoading) return
      if (feedbackTypesError) {
        return toastSweetAlert({
          mode: 'error',
          message: feedbackTypesError.message,
        })
      }

      const options = feedbackTypesData.getAllFeedbackTypes

      setOptions((prev) => ({
        ...prev,
        feedback_types: options,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [feedbackTypesData, feedbackTypesError, feedbackTypesLoading])

  useEffect(() => {
    try {
      if (!selected.userType) return
      if (loadingGroups) return
      if (errorGroups) {
        return toastSweetAlert({
          mode: 'error',
          message: errorGroups.message,
        })
      }

      const options = dataGroups.getOptionsByArea

      setOptions((prev) => ({
        ...prev,
        groups: options,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataGroups, errorGroups, loadingGroups])

  useEffect(() => {
    try {
      if (!selected.group) return
      if (loadingCategories) return
      if (errorCategories) throw new Error(errorCategories.message)

      const options = dataCategories.getOptionsCategoriesByArea
      setOptions((prev) => ({
        ...prev,
        categories: options,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataCategories, errorCategories, loadingCategories])

  useEffect(() => {
    try {
      if (selected.userType !== 'process') return
      if (!selected.category) return
      if (loadingSubCategories) return
      if (errorSubCategories) throw new Error(errorSubCategories.message)
      const options = dataSubCategories.getOptionsSubCategoriesByArea
      setOptions((prev) => ({
        ...prev,
        subCategories: options,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [
    selected.category,
    loadingSubCategories,
    errorSubCategories,
    dataSubCategories,
  ])

  useEffect(() => {
    try {
      if (!selected.category) return
      if (loadingUsersToCategories) return
      if (errorUsersToCategories) {
        return toastSweetAlert({
          mode: 'error',
          message: errorUsersToCategories.message,
        })
      }

      const options = dataUsersToCategories.getUsersByCategory.map((user) => {
        return {
          value: user.id,
          label: `${user.name} ${user.first_name} ${user.last_name}`,
        }
      })

      setOptions((prev) => ({
        ...prev,
        usersToCategories: options,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [
    selected.category,
    loadingUsersToCategories,
    errorUsersToCategories,
    dataUsersToCategories,
  ])

  useEffect(() => {
    try {
      if (loadingUserTypes) return
      if (errorUserTypes) {
        return toastSweetAlert({
          mode: 'error',
          message: errorUserTypes.message,
        })
      }

      const options = dataUserTypes.getAllUserTypes

      setOptions((prev) => ({
        ...prev,
        user_types: options,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingUserTypes, errorUserTypes, dataUserTypes])

  const onSubmit = async (data) => {
    showLoading()
    try {
      if (ratingId) {
        const { data: updateData } = await updateRating({
          variables: {
            updateUserRatingId: +ratingId,
            input: {
              user_id: +data.user_id,
              // rating: +data.rating,
              comment: data.comment,
              feedback_type: data.feedback_type,
              group_id: +data.group_id,
              group_category_id: +data.category_id,
              user_type: data.user_type,
              group_sub_category_id: data.group_sub_category_id
                ? +data.group_sub_category_id
                : null,
            },
          },
        })

        if (updateData.updateUserRating) {
          return toastSweetAlert(
            {
              mode: 'ok',
              message: 'Calificación actualizada correctamente',
            },
            setCloseModal(true)
          )
        }
      }

      const { data: createData } = await createRating({
        variables: {
          input: {
            user_id: +data.user_id,
            // rating: +data.rating,
            comment: data.comment,
            feedback_type: data.feedback_type,
            group_id: +data.group_id,
            group_category_id: +data.category_id,
            user_type: data.user_type,
            group_sub_category_id: data.group_sub_category_id
              ? +data.group_sub_category_id
              : null,
          },
        },
      })
      if (createData.createUserRating) {
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Calificación creada correctamente',
          },
          history.push(backPage)
        )
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
      // setCloseModal(true)
    }
  }

  const handleChangeSelects = (e, name) => {
    let objectToSet = handleSetObject(name, e)
    setSelected((prev) => ({
      ...prev,
      ...objectToSet,
    }))
    setValue(name, e ? e.value : '')
  }

  const handleSetObject = (name, e) => {
    let objectToSet = {}
    switch (name) {
      case 'userType':
        objectToSet = {
          group: false,
          category: false,
          subCategoryId: false,
          user: false,
          userType: e ? e.value : false,
        }
        break
      case 'group':
        objectToSet = {
          category: false,
          subCategoryId: false,
          user: false,
          group: e ? e.value : false,
        }
        break
      case 'category':
        objectToSet = {
          subCategoryId: false,
          user: false,
          category: e ? e.value : false,
        }
        break
      case 'subCategoryId':
        objectToSet = {
          user: false,
          subCategoryId: e ? e.value : false,
        }
        break
      case 'user':
        objectToSet = {
          user: e ? e.value : false,
        }
        break
      default:
        break
    }
    return objectToSet
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          title="Calificación de usuario"
          error={errors}
          // btnSubmit={
          //   ratingId ? 'Actualizar calificación' : 'Crear calificación'
          // }
          btnSubmit="Enviar calificación"
          contentHeader={
            <>
              <div className="row p-3">
                <div className="col-lg-12 p-2 mb-2">
                  <InputController
                    name="user_type"
                    label="Área a calificar"
                    inputType="choosen"
                    options={options.user_types}
                    placeholder="Selecciona un tipo de usuario"
                    control={control}
                    changeAction={(e) => handleChangeSelects(e, 'userType')}
                    valueManual={selected.userType ? selected.userType : ''} // Forzar el valor del select
                  />
                </div>
                {selected.userType && (
                  <>
                    {selected.userType !== 'attention_citizens' && (
                      <>
                        <div className="col-lg-12 p-2 mb-2">
                          <InputController
                            name="group_id"
                            label={
                              selected.userType === 'process'
                                ? 'Trámite'
                                : 'Tipo de reporte'
                            }
                            inputType="choosen"
                            options={options.groups}
                            placeholder={
                              selected.userType === 'process'
                                ? 'Selecciona un trámite'
                                : 'Selecciona un tipo de reporte'
                            }
                            control={control}
                            changeAction={(e) =>
                              handleChangeSelects(e, 'group')
                            }
                            disabled={!selected.userType}
                            valueManual={selected.group ? selected.group : ''} // Forzar el valor del select
                          />
                        </div>
                        <div className="col-lg-12 p-2 mb-2">
                          <InputController
                            name="category_id"
                            label={
                              selected.userType === 'process'
                                ? 'Dependencia'
                                : 'Categoría del reporte'
                            }
                            inputType="choosen"
                            options={options.categories}
                            placeholder={
                              selected.userType === 'process'
                                ? 'Selecciona una dependencia'
                                : 'Selecciona una categoría del reporte'
                            }
                            control={control}
                            changeAction={(e) =>
                              handleChangeSelects(e, 'category')
                            }
                            disabled={!selected.group}
                            valueManual={
                              selected.category ? selected.category : ''
                            } // Forzar el valor del select
                          />
                        </div>
                      </>
                    )}
                    {selected.userType === 'process' && (
                      <div className="col-lg-12 p-2 mb-2">
                        <InputController
                          name="group_sub_category_id"
                          label={
                            selected.userType === 'process'
                              ? 'Tipo de trámite'
                              : 'Subcategoría del reporte'
                          }
                          inputType="choosen"
                          options={options.subCategories}
                          placeholder={
                            selected.userType === 'process'
                              ? 'Selecciona un tipo de trámite'
                              : 'Selecciona una subcategoría del reporte'
                          }
                          control={control}
                          changeAction={(e) =>
                            handleChangeSelects(e, 'subCategoryId')
                          }
                          disabled={!selected.category}
                          valueManual={
                            selected.subCategoryId ? selected.subCategoryId : ''
                          } // Forzar el valor del select
                        />
                      </div>
                    )}
                    <div className="col-lg-12 p-2 mb-2">
                      <InputController
                        name="user_id"
                        label="Usuario a calificar"
                        inputType="choosen"
                        options={options.usersToCategories}
                        placeholder="Selecciona un usuario"
                        control={control}
                        disabled={!selected.category}
                        changeAction={(e) => handleChangeSelects(e, 'user')}
                        valueManual={selected.user ? selected.user : ''} // Forzar el valor del select
                      />
                    </div>
                    <div className="col-lg-12 p-2 mb-2">
                      <InputController
                        name="feedback_type"
                        label="Tipo de retroalimentación"
                        inputType="choosen"
                        options={options.feedback_types}
                        placeholder="Selecciona un tipo de retroalimentación"
                        control={control}
                        disabled={!selected.user}
                      />
                    </div>
                    {/* <div className="col-lg-12">
                  <InputController
                    name="rating"
                    label="Calificación"
                    inputType="rating"
                    placeholder="Ingresa una calificación del 1 al 5"
                    control={control}
                    changeAction={(e) => console.log(e, 'value')}
                  />
                </div> */}
                    <div className="col-lg-12 p-2 mb-2">
                      <InputController
                        name="comment"
                        label="Comentario"
                        inputType="textarea"
                        placeholder="Ingresa un comentario"
                        control={control}
                        disabled={!selected.user}
                      />
                    </div>
                  </>
                )}
              </div>
            </>
          }
        />
      </form>
    </FormProvider>
  )
}

export default FormUsersRatings
